/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line react/no-unstable-nested-components
import React, { ReactNode, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Typography
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useSWR, { useSWRConfig } from 'swr';
import {
  CloudSyncOutlined,
  PhoneOutlined,
  SaveOutlined
} from '@mui/icons-material';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ClearIcon from '@mui/icons-material/Clear';
import WorkIcon from '@mui/icons-material/Work';
import { secondaryColors, themePalette } from '../../theme/themeConfig';
import Api from '../../api';
import StepDetailProjects from './StepDetailProjects';
import { statusStyle } from '../../utils/general';
import RegularInput from '../../components/input/RegularInput';
import { AntSwitch } from '../../components/companySettings/parts';
import ConfirmModal from '../../components/modals/ConfirmModal';
import AvatarGroup from '../../components/AvatarGroup';
import {
  Destination,
  ServiceTime,
  Version
} from '../../utils/types/ProjectType';
import useNotificationsStore from '../../store/zustand/notifications';
import PdfViewerComponent from '../../components/shared/container/pdfViewerContainer';
import { ModalContainer } from '../leads/steps/SelectTermsAndConditions';
import ProjectInspectionBadge from '../../components/shared/ProjectInspectionBadge';
import ProjectAreasPanel from '../../components/shared/ProjectAreasPanel';
import SupervisorAssignWidget from '../../components/shared/SupervisorAssignWidget';
import SupervisorActivityPanel from '../../components/shared/SupervisorActivityPanel';

interface Props {
  // eslint-disable-next-line react/require-default-props
  isClient?: boolean;
}

const DetailProject: React.FC<Props> = function DetailProject({
  isClient = false
}) {
  const { addNotification } = useNotificationsStore((state) => state);
  const [detailProject, setDetailProject] = useState<any>({});
  const [detailProjectEdit, setDetailProjectEdit] = useState<any>({});
  const [editFlag, setEditFlag] = useState<boolean>();
  const [apiEdit, setApiEdit] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
  const [fireDelete, setFireDelete] = useState<boolean>(false);
  const [fireUpdateContract, setFireUpdateContract] = useState<boolean>(false);
  const [showOkModal, setShowOkModal] = useState<boolean>(false);
  const [versions, setVersions] = useState<Version[]>([]);
  const [contractUrl, setContractUrl] = useState<string>('');
  const [contractPreview, setContractPreview] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const urlParams = useParams();
  const { state: params } = useLocation();
  const getProjectByIdAction = isClient
    ? Api.ClientPageApi.getProjectClientById
    : Api.ProjectApi.getProjectById;
  const getProjectHistoryByIdAction = isClient
    ? Api.ClientPageApi.getHistoryVersion
    : Api.ProjectApi.getHistoryVersion;
  const type = params?.type;
  const dayChecked = params?.dayChecked;
  const utcUpadtedAt = params?.utcUpadtedAt;
  const { mutate: projectEnforceGeofencingMutate } = useSWRConfig();

  const urlParamId = urlParams['*'];
  const initialProjectIdFromUrl = location?.state?.id || urlParamId || null;
  const [currentDetailProjectId, setCurrentDetailProjectId] = useState<
    string | null
  >(initialProjectIdFromUrl);
  const [originalProjectIdForVersions, setOriginalProjectIdForVersions] =
    useState<string | null>(initialProjectIdFromUrl);

  useEffect(() => {
    setCurrentDetailProjectId(initialProjectIdFromUrl);
    setOriginalProjectIdForVersions(initialProjectIdFromUrl);
  }, [initialProjectIdFromUrl]);

  const {
    data: responseData,
    error: responseError,
    mutate: mutateDetailProject
  } = useSWR(currentDetailProjectId, getProjectByIdAction);

  const { data: editNamResponse, error: editNameError } = useSWR(
    apiEdit ? { ...detailProjectEdit, url: 'edit-project/name' } : null,
    Api.ProjectApi.changeProjectName
  );

  const { data: cancelProjectResponse, error: cancelProjectError } = useSWR(
    fireDelete ? { ...detailProject, url: 'edit-project/name' } : null,
    Api.ProjectApi.cancelProject
  );

  const { data: updateContractResponse, error: updateContractError } = useSWR(
    fireUpdateContract
      ? { id: detailProject.id, url: 'update-contract' }
      : null,
    Api.ProjectApi.updateContract
  );

  const { data: versionsData, error: versionsError } = useSWR(
    originalProjectIdForVersions
      ? { id: originalProjectIdForVersions, url: 'versions-history' }
      : null,
    getProjectHistoryByIdAction
  );

  useEffect(() => {
    if (versionsData) {
      setVersions(versionsData as Version[]);
    }
    if (versionsError) {
      setVersions([]);
    }
  }, [versionsData, versionsError]);

  useEffect(() => {
    if (updateContractResponse) {
      setFireUpdateContract(false);
      navigate(`/app/leads/edit-lead`, {
        state: { id: (updateContractResponse as { id: string }).id }
      });
      setShowUpdateModal(false);
    }
  }, [updateContractResponse]);

  useEffect(() => {
    if (updateContractError) {
      setFireUpdateContract(false);
      addNotification('Error updating contract', 'error');
      setShowOkModal(true);
    }
  }, [updateContractError]);

  useEffect(() => {
    if (cancelProjectResponse && !cancelProjectError) {
      setDetailProject({
        ...detailProject,
        status: 'Cancelled'
      });
      setShowOkModal(true);
    }
  }, [cancelProjectResponse]);

  useEffect(() => {
    if (showOkModal) {
      setShowDeleteModal(false);
      setShowOkModal(false);
    }
  }, [showOkModal]);

  useEffect(() => {
    if (responseData && !responseError) {
      const auxDestinations = responseData?.proposal?.lead?.destinations.map(
        (destination: Destination) => {
          const formattedServiceTimes = destination.serviceTimes.map(
            (serviceTime: ServiceTime) => {
              const auxStartTime = dayjs()
                .hour(parseFloat(serviceTime?.startTime?.split(':')[0]))
                .minute(parseFloat(serviceTime?.startTime?.split(':')[1]));

              const auxEndTime = dayjs()
                .hour(parseFloat(serviceTime?.endTime?.split(':')[0]))
                .minute(parseFloat(serviceTime?.endTime?.split(':')[1]));

              return {
                ...serviceTime,
                formated24hEndTime: auxEndTime.format('HH:mm'),
                formated24hStartTime: auxStartTime.format('HH:mm'),
                formatedEndTime: auxEndTime.format('hh:mm A'),
                formatedStartTime: auxStartTime.format('hh:mm A'),
                timezone: destination.address.timezone
              };
            }
          );

          return {
            ...destination,
            serviceTimes: formattedServiceTimes
          };
        }
      );

      const auxResponse = {
        ...responseData,
        id: responseData?.id,
        proposal: {
          ...responseData?.proposal,
          lead: {
            ...responseData?.proposal?.lead,
            destinations: auxDestinations
          }
        }
      };

      setDetailProject(auxResponse);
      setContractUrl(responseData.contractUrl);
    }
    if (responseError) {
      console.error('Error fetching project details:', responseError);
      setDetailProject({});
    }
  }, [responseData, responseError]);

  const handleRedirect = () => {
    if (params?.lastPage) {
      navigate(params.lastPage, { state: params });
    } else if (isClient) {
      navigate('/customer-page/projects/list');
    } else {
      navigate('/app/projects/list');
    }
  };

  useEffect(() => {
    if (editNamResponse) {
      setApiEdit(false);
      mutateDetailProject(undefined, true);
    }
  }, [editNamResponse, mutateDetailProject]);

  useEffect(() => {
    if (editNameError) {
      setApiEdit(false);
    }
  }, [editNameError]);

  const header = () => {
    return (
      <Box>
        <Typography
          sx={{
            ...statusStyle(detailProject?.status)
          }}
          variant="body_200"
        >
          {detailProject?.status}
        </Typography>
      </Box>
    );
  };

  const parseProjectData = () => {
    const clientId = detailProject?.proposal?.lead?.client?.id;
    const clientPhone = detailProject?.proposal?.lead?.client?.phone;
    const clientName = detailProject?.proposal?.lead?.client?.firstName;
    const clientLastName = detailProject?.proposal?.lead?.client?.lastName;
    const businessName = detailProject?.proposal?.lead?.client?.businessName;
    const clientPhoneExtension =
      detailProject?.proposal?.lead?.client?.phoneExtension;

    return [
      {
        clientId,
        labels: [
          {
            icon: <AccountCircleOutlinedIcon fontSize="small" />,
            label: `${clientName} ${clientLastName}`
          },
          {
            icon: <WorkIcon fontSize="small" />,
            label: businessName
          },
          {
            icon: <PhoneOutlined fontSize="small" />,
            label: `${clientPhone}${
              clientPhoneExtension ? ` Ext.${clientPhoneExtension}` : ''
            }`
          }
        ],
        title: t('CUSTOMER.clientInformation')
      }
    ];
  };

  const handleLoadVersion = (projectId: string) => {
    setCurrentDetailProjectId(projectId);
    setEditFlag(false);
  };

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 3, paddingTop: 2 }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'row',
          gap: 2,
          justifyContent: 'left'
        }}
      >
        <Box
          sx={{
            alignContent: 'center',
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            paddingLeft: 4
          }}
        >
          <Typography
            sx={{
              alignItems: 'center',
              display: 'flex',
              fontSize: '28px',
              fontWeight: '900',
              gap: 2,
              justifyContent: 'center'
            }}
            variant="primary-bold"
          >
            <ArrowBackIcon fill="grey" onClick={() => handleRedirect()} />
            {t('MENU.projects')}
          </Typography>
        </Box>
        <Button
          onClick={() => {
            if (currentDetailProjectId) {
              mutateDetailProject();
            }
          }}
          variant="text"
        >
          <Typography
            sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}
            variant="body_100"
          >
            <CloudSyncOutlined fontSize="small" />

            {t('GENERAL.sync')}
          </Typography>
        </Button>
      </Box>
      <Grid
        container
        pl={6}
        spacing={2}
        style={{ backgroundColor: `${themePalette.BACKGROUND}` }}
      >
        {detailProject?.proposal?.lead && (
          <Grid
            sx={{
              backgroundColor: 'white',
              borderRight: '1px solid #E2E4EA',
              display: 'flex',
              flexDirection: 'column',
              gap: 0,
              marginBottom: '16px',
              padding: 0
            }}
            xs={3}
          >
            {/* ── Project identity header ── */}
            <Box sx={{ borderBottom: '1px solid #E2E4EA', p: '16px' }}>
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  gap: '12px',
                  mb: '10px'
                }}
              >
                <Box
                  sx={{
                    alignItems: 'center',
                    backgroundColor: '#189A90',
                    borderRadius: '10px',
                    color: '#fff',
                    display: 'flex',
                    flexShrink: 0,
                    fontSize: '16px',
                    fontWeight: 800,
                    height: 44,
                    justifyContent: 'center',
                    width: 44
                  }}
                >
                  {(detailProject?.proposal?.lead?.name || 'P')
                    .slice(0, 2)
                    .toUpperCase()}
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  {/* Name row: input or text + edit button inline */}
                  <Box sx={{ alignItems: 'center', display: 'flex', gap: 0.5 }}>
                    {editFlag ? (
                      <RegularInput
                        customStyle={{ flex: 1 }}
                        onChange={(value) =>
                          setDetailProjectEdit({
                            ...detailProjectEdit,
                            proposal: {
                              ...detailProjectEdit?.proposal,
                              lead: {
                                ...detailProjectEdit?.proposal?.lead,
                                name: value
                              }
                            }
                          })
                        }
                        value={detailProjectEdit?.proposal?.lead?.name}
                      />
                    ) : (
                      <Typography
                        sx={{
                          color: '#0f1c2e',
                          fontSize: '14px',
                          fontWeight: 700,
                          lineHeight: 1.3,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        {detailProject?.proposal?.lead?.name}
                      </Typography>
                    )}
                    {!isClient &&
                      detailProject?.status !== 'Cancelled' &&
                      detailProject?.status !== 'Completed' && (
                        <IconButton
                          onClick={() => {
                            setEditFlag(!editFlag);
                            if (editFlag) setApiEdit(true);
                            else setDetailProjectEdit(detailProject);
                          }}
                          size="small"
                          sx={{ flexShrink: 0 }}
                        >
                          {!editFlag ? (
                            <BorderColorOutlinedIcon
                              fontSize="small"
                              sx={{ color: '#7D8090' }}
                            />
                          ) : (
                            <SaveOutlined fontSize="small" />
                          )}
                        </IconButton>
                      )}
                  </Box>
                  {/* Badges row */}
                  {!editFlag && (
                    <Box
                      sx={{
                        alignItems: 'center',
                        display: 'flex',
                        gap: '6px',
                        mt: '4px'
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: '#EBF4FF',
                          border: '1px solid #A2CDEC',
                          borderRadius: '20px',
                          px: '8px',
                          py: '2px'
                        }}
                      >
                        <Typography
                          sx={{
                            color: '#005DA2',
                            fontSize: '11px',
                            fontWeight: 600
                          }}
                        >
                          {detailProject?.proposal?.lead?.projectType}
                        </Typography>
                      </Box>
                      <Typography sx={{ color: '#7D8090', fontSize: '11px' }}>
                        {detailProject?.versionName}
                      </Typography>
                      <Box
                        sx={{
                          ...statusStyle(detailProject?.status),
                          borderRadius: '20px',
                          px: '8px',
                          py: '2px'
                        }}
                      >
                        <Typography sx={{ fontSize: '11px', fontWeight: 600 }}>
                          {detailProject?.status}
                        </Typography>
                      </Box>
                    </Box>
                  )}
                  {detailProject?.id && (
                    <Box sx={{ mt: '6px' }}>
                      <ProjectInspectionBadge projectId={detailProject.id} />
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>

            {/* ── Contract period ── */}
            <Box sx={{ borderBottom: '1px solid #E2E4EA', p: '14px 16px' }}>
              <Typography
                sx={{
                  color: '#7D8090',
                  fontSize: '10px',
                  fontWeight: 700,
                  letterSpacing: '0.06em',
                  mb: '8px',
                  textTransform: 'uppercase'
                }}
              >
                Contract Period
              </Typography>
              {(() => {
                const start = detailProject?.proposal?.lead?.projectStartDate;
                const end = detailProject?.proposal?.lead?.projectEndDate;
                const type = detailProject?.proposal?.lead?.projectType;
                const pct =
                  start && end
                    ? Math.min(
                        100,
                        Math.max(
                          0,
                          Math.round(
                            (dayjs().diff(dayjs(start), 'day') /
                              dayjs(end).diff(dayjs(start), 'day')) *
                              100
                          )
                        )
                      )
                    : 0;
                return (
                  <>
                    <Typography
                      sx={{
                        color: '#0f1c2e',
                        fontSize: '13px',
                        fontWeight: 600
                      }}
                    >
                      {start ? dayjs(start).format('MMM D, YYYY') : '—'}
                      {type !== 'Ad-Hoc' && end
                        ? ` — ${dayjs(end).format('MMM D, YYYY')}`
                        : ''}
                    </Typography>
                    {start && end && type !== 'Ad-Hoc' && (
                      <Box sx={{ mt: '8px' }}>
                        <Box
                          sx={{
                            backgroundColor: '#E2E4EA',
                            borderRadius: '4px',
                            height: '4px',
                            overflow: 'hidden',
                            width: '100%'
                          }}
                        >
                          <Box
                            sx={{
                              backgroundColor: '#005DA2',
                              borderRadius: '4px',
                              height: '100%',
                              width: `${pct}%`
                            }}
                          />
                        </Box>
                        <Typography
                          sx={{ color: '#7D8090', fontSize: '11px', mt: '4px' }}
                        >
                          {pct}% elapsed
                        </Typography>
                      </Box>
                    )}
                  </>
                );
              })()}
            </Box>

            {/* ── Client ── */}
            <Box sx={{ borderBottom: '1px solid #E2E4EA', p: '14px 16px' }}>
              <Typography
                sx={{
                  color: '#7D8090',
                  fontSize: '10px',
                  fontWeight: 700,
                  letterSpacing: '0.06em',
                  mb: '8px',
                  textTransform: 'uppercase'
                }}
              >
                Client
              </Typography>
              {(() => {
                const c = detailProject?.proposal?.lead?.client;
                const clientId = c?.id;
                return (
                  <Box
                    onClick={
                      !isClient
                        ? () =>
                            navigate(`/app/crm/edit/${clientId}`, {
                              state: { lastPage: location.pathname }
                            })
                        : undefined
                    }
                    sx={{
                      cursor: isClient ? 'default' : 'pointer',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '6px'
                    }}
                  >
                    {[
                      {
                        icon: (
                          <AccountCircleOutlinedIcon sx={{ fontSize: 15 }} />
                        ),
                        text: `${c?.firstName || ''} ${
                          c?.lastName || ''
                        }`.trim()
                      },
                      {
                        icon: <WorkIcon sx={{ fontSize: 15 }} />,
                        text: c?.businessName
                      },
                      {
                        icon: <PhoneOutlined sx={{ fontSize: 15 }} />,
                        text: `${c?.phone || ''}${
                          c?.phoneExtension ? ` Ext.${c.phoneExtension}` : ''
                        }`
                      }
                    ]
                      .filter((r) => r.text)
                      .map(({ icon, text }) => (
                        <Box
                          key={text}
                          sx={{
                            alignItems: 'center',
                            color: '#4B4D56',
                            display: 'flex',
                            gap: '8px'
                          }}
                        >
                          <Box sx={{ color: '#7D8090', display: 'flex' }}>
                            {icon}
                          </Box>
                          <Typography sx={{ fontSize: '13px' }}>
                            {text}
                          </Typography>
                        </Box>
                      ))}
                  </Box>
                );
              })()}
            </Box>

            {!isClient && (
              <>
                {/* ── Supervisor ── */}
                <Box sx={{ borderBottom: '1px solid #E2E4EA', p: '14px 16px' }}>
                  <Typography
                    sx={{
                      color: '#7D8090',
                      fontSize: '10px',
                      fontWeight: 700,
                      letterSpacing: '0.06em',
                      mb: '8px',
                      textTransform: 'uppercase'
                    }}
                  >
                    Supervisor
                  </Typography>
                  <SupervisorAssignWidget
                    currentSupervisor={
                      detailProject?.supervisor ??
                      detailProject?.proposal?.lead?.supervisor
                    }
                    currentSupervisorRate={detailProject?.supervisorRate}
                    onChanged={(sup, rate) => {
                      setDetailProject({
                        ...detailProject,
                        supervisor: sup,
                        supervisorRate: rate
                      });
                    }}
                    projectId={detailProject?.id}
                  />
                </Box>

                {/* ── Supervisor Activity ── */}
                {detailProject?.id && (
                  <SupervisorActivityPanel projectId={detailProject.id} />
                )}

                {/* ── Team ── */}
                <Box sx={{ borderBottom: '1px solid #E2E4EA', p: '14px 16px' }}>
                  <Typography
                    sx={{
                      color: '#7D8090',
                      fontSize: '10px',
                      fontWeight: 700,
                      letterSpacing: '0.06em',
                      mb: '8px',
                      textTransform: 'uppercase'
                    }}
                  >
                    Team
                  </Typography>
                  {(() => {
                    const techs =
                      detailProject?.proposal?.lead?.technicians?.filter(
                        (t: any, i: number, s: any) =>
                          i === s.findIndex((x: any) => x.id === t.id)
                      );
                    return techs?.length > 0 ? (
                      <AvatarGroup max={10} users={techs} />
                    ) : (
                      <Typography sx={{ color: '#CBCCD3', fontSize: '12px' }}>
                        No technicians assigned
                      </Typography>
                    );
                  })()}
                </Box>

                {/* ── Enforce Geofencing ── */}
                {detailProject?.status !== 'Cancelled' &&
                  detailProject?.status !== 'Completed' && (
                    <Box
                      sx={{
                        alignItems: 'center',
                        borderBottom: '1px solid #E2E4EA',
                        display: 'flex',
                        justifyContent: 'space-between',
                        p: '12px 16px'
                      }}
                    >
                      <Typography sx={{ color: '#4B4D56', fontSize: '13px' }}>
                        Enforce Geofencing
                      </Typography>
                      <FormControlLabel
                        control={
                          <AntSwitch
                            checked={detailProject?.enforceGeofencing}
                          />
                        }
                        disabled={false}
                        label=""
                        onChange={() => {
                          setDetailProject({
                            ...detailProject,
                            enforceGeofencing: !detailProject.enforceGeofencing
                          });
                          addNotification(
                            t('NOTIFICATION.TOAST.projectUpdatedSuccess'),
                            'success'
                          );
                          projectEnforceGeofencingMutate(
                            '/project/enforceGeofencing',
                            Api.ProjectApi.patchChangeProjectEnforceGeofencing({
                              enforceGeofencing:
                                !detailProject.enforceGeofencing,
                              id: detailProject.id
                            })
                          );
                        }}
                        sx={{ m: 0 }}
                      />
                    </Box>
                  )}

                {/* ── Project areas ── */}
                {detailProject?.id && (
                  <ProjectAreasPanel projectId={detailProject.id} />
                )}

                {/* ── Inspections toggle ── */}
                {detailProject?.status !== 'Cancelled' &&
                  detailProject?.status !== 'Completed' && (
                    <Box
                      sx={{
                        alignItems: 'center',
                        borderBottom: '1px solid #E2E4EA',
                        display: 'flex',
                        justifyContent: 'space-between',
                        p: '12px 16px'
                      }}
                    >
                      <Typography sx={{ color: '#4B4D56', fontSize: '13px' }}>
                        Inspections
                      </Typography>
                      <FormControlLabel
                        control={
                          <AntSwitch
                            checked={detailProject?.inspectionsEnabled ?? true}
                          />
                        }
                        disabled={false}
                        label=""
                        onChange={() => {
                          const next = !(
                            detailProject?.inspectionsEnabled ?? true
                          );
                          setDetailProject({
                            ...detailProject,
                            inspectionsEnabled: next
                          });
                          addNotification(
                            t('NOTIFICATION.TOAST.projectUpdatedSuccess'),
                            'success'
                          );
                          projectEnforceGeofencingMutate(
                            '/projects/inspections',
                            Api.ProjectApi.patchProjectInspectionsEnabled({
                              id: detailProject.id,
                              inspectionsEnabled: next
                            })
                          );
                        }}
                        sx={{ m: 0 }}
                      />
                    </Box>
                  )}

                {/* ── Surprise inspections toggle ── */}
                {detailProject?.status !== 'Cancelled' &&
                  detailProject?.status !== 'Completed' && (
                    <Box
                      sx={{
                        alignItems: 'center',
                        borderBottom: '1px solid #E2E4EA',
                        display: 'flex',
                        justifyContent: 'space-between',
                        p: '12px 16px'
                      }}
                    >
                      <Typography sx={{ color: '#4B4D56', fontSize: '13px' }}>
                        Surprise inspections (Abe)
                      </Typography>
                      <FormControlLabel
                        control={
                          <AntSwitch
                            checked={detailProject?.abeInspectEnabled ?? false}
                          />
                        }
                        disabled={false}
                        label=""
                        onChange={() => {
                          const next = !(
                            detailProject?.abeInspectEnabled ?? false
                          );
                          setDetailProject({
                            ...detailProject,
                            abeInspectEnabled: next
                          });
                          addNotification(
                            t('NOTIFICATION.TOAST.projectUpdatedSuccess'),
                            'success'
                          );
                          projectEnforceGeofencingMutate(
                            '/projects/abe-inspect',
                            Api.ProjectApi.patchProjectAbeInspectEnabled({
                              abeInspectEnabled: next,
                              id: detailProject.id
                            })
                          );
                        }}
                        sx={{ m: 0 }}
                      />
                    </Box>
                  )}
              </>
            )}

            {/* ── Action buttons ── */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                mt: 'auto',
                p: '14px 16px'
              }}
            >
              {!isClient &&
                detailProject.status !== 'Cancelled' &&
                contractUrl && (
                  <Button
                    fullWidth
                    onClick={() => setContractPreview(true)}
                    sx={{
                      borderColor: '#E2E4EA',
                      color: '#0f1c2e',
                      fontSize: '12px',
                      fontWeight: 600,
                      textTransform: 'none'
                    }}
                    variant="outlined"
                  >
                    <Box
                      sx={{ alignItems: 'center', display: 'flex', gap: '6px' }}
                    >
                      <i
                        className="custom-icon icon-contract"
                        style={{ fontSize: 13 }}
                      />
                      Show Contract
                    </Box>
                  </Button>
                )}
              {!isClient &&
                detailProject?.status !== 'Cancelled' &&
                detailProject?.status !== 'Contract Updated' && (
                  <Button
                    fullWidth
                    onClick={() =>
                      detailProject.contratctInNegotiationIdsInformation?.leadId
                        ? navigate(`/app/leads/edit-lead`, {
                            state: {
                              id: detailProject
                                .contratctInNegotiationIdsInformation.leadId
                            }
                          })
                        : setShowUpdateModal(true)
                    }
                    sx={{
                      borderColor: '#E2E4EA',
                      color: '#0f1c2e',
                      fontSize: '12px',
                      fontWeight: 600,
                      textTransform: 'none'
                    }}
                    variant="outlined"
                  >
                    <Box
                      sx={{ alignItems: 'center', display: 'flex', gap: '6px' }}
                    >
                      <i
                        className="custom-icon icon-edit"
                        style={{ fontSize: 13 }}
                      />
                      {detailProject.contratctInNegotiationIdsInformation
                        ?.leadId
                        ? 'Go to Contract in Negotiation'
                        : 'Update Contract'}
                    </Box>
                  </Button>
                )}
              {!isClient && (
                <Button
                  fullWidth
                  disabled={
                    detailProject?.status === 'Cancelled' ||
                    detailProject?.status === 'Completed'
                  }
                  onClick={() => setShowDeleteModal(true)}
                  sx={{
                    '&:hover': {
                      backgroundColor: '#FFF5F5',
                      borderColor: '#EF9A9A'
                    },
                    borderColor: '#FFCDD2',
                    color: '#D32F2F',
                    fontSize: '12px',
                    fontWeight: 600,
                    textTransform: 'none'
                  }}
                  variant="outlined"
                >
                  <Box
                    sx={{ alignItems: 'center', display: 'flex', gap: '6px' }}
                  >
                    <i
                      className="custom-icon icon-close-circle"
                      style={{ fontSize: 13 }}
                    />
                    Cancel Project
                  </Box>
                </Button>
              )}
            </Box>
          </Grid>
        )}
        <Grid item xs={9}>
          <StepDetailProjects
            dayChecked={dayChecked}
            detailProject={detailProject}
            isClient={isClient}
            onLoadVersion={handleLoadVersion}
            projectType={detailProject?.proposal?.lead?.projectType}
            refresh={() => {
              if (currentDetailProjectId) mutateDetailProject();
            }}
            typeView={type}
            utcUpadtedAt={utcUpadtedAt}
            versions={versions}
          />
        </Grid>
      </Grid>
      {showDeleteModal && (
        <ConfirmModal
          modalText={t('MODAL.confirmCancelProject')}
          modalType="project"
          setSentFlag={setFireDelete}
          setShowModal={setShowDeleteModal}
          setShowOkModal={setShowOkModal}
        />
      )}
      {showUpdateModal && (
        <ConfirmModal
          isLoading={fireUpdateContract}
          modalText="Are you sure you want to update this contract?"
          modalType="updateContract"
          setSentFlag={setFireUpdateContract}
          setShowModal={setShowUpdateModal}
          setShowOkModal={() => {}}
        />
      )}
      <Modal onClose={() => setContractPreview(false)} open={contractPreview}>
        <ModalContainer>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '2px',
              justifyContent: 'space-between',
              marginTop: '10px',
              mb: '10px'
            }}
          >
            <Typography
              sx={{
                fontSize: '24px',
                fontWeight: 'bolder',
                variant: 'title'
              }}
            >
              Preview
            </Typography>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end'
              }}
            >
              <IconButton
                aria-label="menu-close"
                color="inherit"
                edge="start"
                onClick={() => setContractPreview(false)}
                sx={{ mr: 2 }}
              >
                <ClearIcon />
              </IconButton>
            </Box>
          </Box>
          <Box sx={{ width: '500px' }}>
            <PdfViewerComponent file={contractUrl} />
          </Box>
        </ModalContainer>
      </Modal>
    </Box>
  );
};

export default DetailProject;
